export default __webpack_public_path__ + "static/media/explore-image-1.787245e2.jpg";